import '@/modules/global';
import Accordian from '@/modules/accordian';

if(document.querySelectorAll('.js-accordian').length > 0){
    document.querySelectorAll('.js-accordian').forEach((ele)=>{
        new Accordian(
            ele
        )
    })
}